import { loader } from 'graphql.macro'

export default async function exportInvoiceToQbo ({ dataLoaders, variables }) {
  const schema = loader('./exportInvoiceToQbo.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id
    }
  })
  return response.exportInvoiceToQuickbooks
}
